import { useContext } from 'react'
import { AuthContext } from '@/context/AuthContext'

export function useHandleSignOut() {
  const { googleSignOut, microsoftSignOut } = useContext(AuthContext)

  return async () => {
    try {
      const signInMethod = localStorage.getItem('signin_method')
      if (signInMethod === 'microsoft') {
        await microsoftSignOut()
      } else {
        await googleSignOut()
      }
    } catch (error) {
      console.error(error)
    }
  }
}
